module.exports = __webpack_public_path__ + "static/media/DWFuturaLatin1.196df43d.woff";